(function () {
  var toggle = document.querySelector('.site-header__toggle');
  var mobileNav = document.getElementById('MobileNav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
      var label = toggle.querySelector('.site-header__toggle-text');
      if (label) label.textContent = open ? 'Menu' : 'Close';
    });
  }

  var grid = document.querySelector('[data-yacht-grid]');
  if (grid) {
    var filters = document.querySelectorAll('[data-filter]');
    var empty = document.querySelector('[data-empty-state]');
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-yacht-card]'));
    var matchesGuests = function (capacity, filter) {
      if (filter === 'all') return true;
      var cap = parseInt(capacity, 10);
      if (filter === '20+') return cap >= 20;
      return cap <= parseInt(filter, 10);
    };
    var applyFilters = function () {
      var guests = document.querySelector('[data-filter="guests"]').value;
      var destination = document.querySelector('[data-filter="destination"]').value;
      var duration = document.querySelector('[data-filter="duration"]').value;
      var shown = 0;
      cards.forEach(function (card) {
        var ok = matchesGuests(card.dataset.guests, guests) &&
          (destination === 'all' || card.dataset.destination === destination) &&
          (duration === 'all' || card.dataset.duration.indexOf(duration) !== -1);
        card.hidden = !ok;
        if (ok) shown += 1;
      });
      if (empty) empty.hidden = shown !== 0;
    };
    filters.forEach(function (filter) { filter.addEventListener('change', applyFilters); });
  }

  document.querySelectorAll('.js-mailto-form').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var to = form.dataset.to || 'contact@findayacht.com';
      var subject = form.dataset.subject || 'Find A Yacht inquiry';
      var lines = [];
      Array.prototype.slice.call(form.elements).forEach(function (el) {
        if (!el.name || el.type === 'submit' || el.type === 'button') return;
        lines.push(el.name + ': ' + el.value);
      });
      window.location.href = 'mailto:' + encodeURIComponent(to) + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(lines.join('\n'));
      var thanks = form.querySelector('.form-thanks');
      if (thanks) thanks.hidden = false;
    });
  });
})();
